export default () => {

  $("#agencyAdviceMark").on("click", function(){
    $("#agencyAdvice").toggle();
  });

  $("#agencyAdviceClose").on("click", function(){
    $("#agencyAdvice").toggle();
  });

}
